import { render, staticRenderFns } from "./Plan2.vue?vue&type=template&id=0487850e&"
import script from "./Plan2.vue?vue&type=script&lang=js&"
export * from "./Plan2.vue?vue&type=script&lang=js&"
import style0 from "./Plan2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports